module.exports = __webpack_public_path__ + "media/cortina/guia-der-entreparedes-f7eedbcd.png";